import { render } from "./SignUpComponent.vue?vue&type=template&id=a127dc42&scoped=true&class=max-w-lg"
import script from "./SignUpComponent.vue?vue&type=script&lang=js"
export * from "./SignUpComponent.vue?vue&type=script&lang=js"

import "./SignUpComponent.vue?vue&type=style&index=0&id=a127dc42&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a127dc42"]])

export default __exports__